import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2385e7ae&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2385e7ae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2385e7ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2385e7ae')) {
      api.createRecord('2385e7ae', component.options)
    } else {
      api.reload('2385e7ae', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2385e7ae&scoped=true", function () {
      api.rerender('2385e7ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/logs/index.vue"
export default component.exports